import React from 'react';
import ActivityLog from '../workspace/ActivityLog';
import './AdminDashboard.css';
import '../workspace/Members.css';
import Banner from '../../ui/Banner';

const PlatformActivity = ({ activeTab, setActiveTab }) => {
  return (
    <div className="tm-page" style={{ padding: '0 0 40px 0' }}>
      <Banner
        title="User Management"
        subtitle="Manage user accounts, roles, and access across your platform."
        type="page-header"
      />

      <div className="tm-section-tabs">
        <button
          className={`tm-section-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          <i className="fas fa-users"></i> All Users
        </button>
        <div className="tm-tab-divider"></div>
        <button
          className={`tm-section-tab ${activeTab === 'audit-logs' ? 'active' : ''}`}
          onClick={() => setActiveTab('audit-logs')}
        >
          <i className="fas fa-history"></i> Audit Logs
        </button>
        <div className="tm-tab-divider"></div>
        <button
          className={`tm-section-tab ${activeTab === 'platform-activity' ? 'active' : ''}`}
          onClick={() => setActiveTab('platform-activity')}
        >
          <i className="fas fa-chart-line"></i> Platform Activity
        </button>
      </div>
      <div className="tm-horizontal-divider"></div>

      <div
        className="animate-fade-in"
        style={{ padding: '12px 0', flex: 1, display: 'flex', flexDirection: 'column' }}
      >
        {/* Render ActivityLog directly but with styles overriding its default margin/padding if needed */}
        <div
          className="al-embedded"
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
          }}
        >
          <ActivityLog embedded={true} />
        </div>
      </div>
    </div>
  );
};

export default PlatformActivity;
